import { render } from "./NewClient.vue?vue&type=template&id=ba79b02e&scoped=true"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"

import "./NewClient.vue?vue&type=style&index=0&id=ba79b02e&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba79b02e"]])

export default __exports__